/* eslint-disable */
<template>
  <div class="availabilities">
    <AdminNavigation ref="navigation" indexProps="4" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Upcoming Availability</h1></div>
        <div class="header-sub-title">The following is a summary of specialist availability, in order that it occurs.</div>
      </div>
    </div>
    <div class="panel">
      <AdminAvailabilityMenu indexProps="0" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-select style="max-width: 200px" @input="search()" class="mr-1" filterable clearable placeholder="Specialist" v-model="listParam.SpecialistID">
                <el-option v-for="item in specialists" :value="item.id" :key="item.id" :label="item.fullName">{{item.fullName}}</el-option>
              </el-select>
              <el-select style="max-width: 200px" class="mr-1" @input="search()" clearable filterable placeholder="Specialty" v-model="listParam.QualificationID">
                <el-option v-for="item in qualification" :value="item.id" :key="item.id" :label="item.name">{{item.name}}</el-option>
              </el-select>
              <el-select style="max-width: 240px" class="mr-1" @input="search()" clearable filterable placeholder="Location" v-model="listParam.LocationID">
                <el-option v-for="item in locations" :key="item.id" :value="item.id" :label="item.fullLocation">{{item.fullLocation}}</el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <el-table @row-click="RowClick" :data="allAvailabilities" ref="bookingTable" :default-sort="{prop: 'AvailabilityDate', order: 'ascending'}" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
            <el-table-column
                width="150"
                sortable="custom"
                show-overflow-tooltip
                label="Specialist"
                prop="SpecialistName"
            >
              <template slot-scope="scope">
                <span>{{getSpecialistName(scope.row.Specialist)}}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="150"
                sortable="custom"
                show-overflow-tooltip
                label="Date"
                prop="AvailabilityDate"
            >
              <template slot-scope="scope">
                <span>{{formatDate(scope.row.AvailabilityDate)}}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                sortable="custom"
                show-overflow-tooltip
                label="Specialty"
                prop="QualificationName"
            >
              <template slot-scope="scope">
                <span>{{scope.row.Specialist.Qualifications.map(item => item.QualificationName).join(', ')}}</span>
              </template>
            </el-table-column>
            <el-table-column
                width="200"
                sortable="custom"
                show-overflow-tooltip
                label="Number Of Bookings"
                prop="TotalTimeslotsCount"
            >
              <template slot-scope="scope">
                <span>{{scope.row.NumberOfBookings}} / {{scope.row.TotalTimeslotsCount}}</span>
              </template>
            </el-table-column>
            <el-table-column
                sortable="custom"
                show-overflow-tooltip
                label="Locations"
                prop="LocationName"
            >
              <template slot-scope="scope">
                <span>{{decodeURIComponent(scope.row.Location.LocationName)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminAvailabilityMenu from "@/components/AdminAvailabilityMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminAvailabilities",
  components: {
    AdminNavigation,
    AdminAvailabilityMenu,
    Header,
  },
  data() {
    return {
      specialists: [],
      totalCount: 0,
      availabilities: [],
      allAvailabilities: [],
      limit: 10,
      pagination: utilities.initPagination(),
      bySpecialist: false,
      qualification: [],
      locations: [],
      byDate: false,
      byBooking: false,
      byLocation: false,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        SpecialistID: '',
        QualificationID: '',
        StartDate: window.moment().format('YYYY-MM-DD'),
        EndDate: '',
        LocationID: '',
        orderBy: 4,
        ascOrDesc: 'ASC',
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    getSpecialistName(item) {
      return utilities.getSpecialistFullNameUpper(item)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    RowClick(row) {
      console.log(row)
      this.$router.push('admin-availability-bookings?id=' + row.Specialist.SpecialistID + '&date=' + row.AvailabilityDate)
    },
    sortParam(v) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },
    formatDate(dateToFormat) {
      return utilities.formatDate(dateToFormat, "DD/MM/YYYY")
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      var {specialistAvailabilities, total} = await utilities.getAvailabilitiesInMenus(this.listParam)
      this.totalCount = total
      this.allAvailabilities = _.cloneDeep(specialistAvailabilities)
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
    async loadDefaultData() {
      const apiArr = [utilities.getQualifications(), utilities.getLocations(), utilities.getSpecialists()]
      const r = await Promise.all(apiArr)
      this.qualification = r[0]
      this.locations = r[1]
      this.specialists = r[2]
    },
  },
  async beforeMount() {
    this.$store.dispatch("loading/setLoadComponent", true)
    $('body>.tooltip').remove()
    await this.loadData()
    await this.loadDefaultData()
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
